import { Component, Vue, Prop } from 'vue-property-decorator';
import { DuplicateCheckResult } from '@/common/types/AllTypesExports';

@Component({
    components: {},
})
export default class LinkCompany extends Vue {
    @Prop({ required: true, default: () => null })
    dupeResult!: DuplicateCheckResult;

    @Prop({ required: false, default: () => "you" })
    entityName!: string;

    get you() {
        return this.entityName == "you" ? "you" : `your ${this.entityName}`;
    }
    
    get your() {
        return this.entityName == "you" ? "your" : `your ${this.entityName}'s`;
    }

    get me() {
        return this.entityName == "you" ? "me" : `my ${this.entityName}`;
    }

    get name() {
        return this.entityName == "you" ? "person" : `${this.entityName}`;
    }

    get isCompanyMemberType() {
        return this.entityName != "you";
    }

    continueWithExistingParent() {
        this.$emit('continue-with-parent');
        this.dupeResult.ignored = true;
    }
}